import React from 'react'
import { Button, Tooltip } from 'antd'
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const ViewQuotationPdfButton = ({ url, ...props }) => {
    return (
        <Tooltip title='Ver cotización en PDF'>
            <Button
                color='danger'
                variant='link'
                href={url}
                target='_blank'
                rel='noopener noreferrer'
                icon={<FontAwesomeIcon icon={faFilePdf} />}
                {...props}
            />
        </Tooltip>
    )
}

// Marca el componente como un botón de Ant Design para que sea tratado como tal por los componentes que lo requieren
ViewQuotationPdfButton.__ANT_BUTTON = true;